
export const UploadFileType = {
  //Global
  image: "image",
  audio: "audio",
  file: "document",
  video: "video",
};

